import styled from 'styled-components';
import { BREAKPOINTS } from '~/components/theme/constants';

export const FooterContent = styled.div`
  ${({ theme }): string => `
    grid-column: 2;
    grid-row: 3;
    align-self: end;
    padding-bottom: ${theme.space.$9};
    
    @media screen and (max-width: ${BREAKPOINTS.SM}) {
      grid-column: 1;
      margin-top: auto;
    }
  `}
`;
